import axios from 'axios';

import { apiBaseUrl } from '@/environment/environment';
import { appLocalStorage, appSessionStorage } from '@/app/shared/services';
import { jwt } from '@/app/shared/services';
// import app from '@/main'; // import the instance

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config = {
  baseURL: apiBaseUrl
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 **/
const httpClient = axios.create(config);

/**
 * Auth interceptors
 * @description Configuration related to AUTH token can be done in interceptors.
 * Currenlty it is just doing nothing but idea to to show the capability of axios and its interceptors
 * In future, interceptors can be created into separate files and consumed into multiple http clients
 * @param {*} config
 */
const reqStartInterceptor = config => {
  /** set progress start flag */
  // app.$Progress.start(); // for every request start the progress


  if(config && config.url.endsWith('/')) {
    config.url = config.url.slice(0, config.url.length-1);
  }
  return config;
};

const authInterceptor = config => {
  /** add auth token */
  let dl_token = appLocalStorage.getItem('dl_token');
  let pe_token = appLocalStorage.getItem('pe_token');
  let appScopeIdentity = appLocalStorage.getItem('app.scope.identity');

  // console.log('appScopeIdentity -> ', appScopeIdentity);

  if(config && config.url && config.url.indexOf("priceeye") > -1) {
    if (appScopeIdentity) {
      config.headers['Authorization'] = `Token ${ appScopeIdentity }`
    } 
    // else if (pe_token) {
    //   config.headers['Authorization'] = `Token ${ pe_token.slice(1, -1) }`
    // }
    
  } else if (dl_token) {
    config.headers['Authorization'] = `Bearer ${ dl_token.slice(1, -1) }`
  }

  return config;
};

const loggerInterceptor = config => {
  /** Add logging here */
  return config;
};

const reqEndInterceptor = response => {
  /** set progress end flag */
  // app.$Progress.finish(); // finish when a response is received
  return response;
};

/** Adding the request interceptors */
httpClient.interceptors.request.use(reqStartInterceptor);
httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.request.use(loggerInterceptor);

/** Adding the response interceptors */
httpClient.interceptors.response.use(reqEndInterceptor);
httpClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    /** Do something with response error */
    return Promise.reject(error);
  }
);

export { httpClient };
